<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { ScoringSurveyEmailSenderViewModel } from "@Evaluation/AlternativesSurveys/Components/ScoringSurveyEmailSender";

    @Component({
        props: {
            viewModel: { type: Object, required: true }
        }
    })
    export default class ScoringSurveyEmailSender extends Vue
    {
        get vm(): ScoringSurveyEmailSenderViewModel { return this.$props.viewModel as ScoringSurveyEmailSenderViewModel; }
        get opened(): boolean { return this.vm?.opened ?? false; }

        get numberOfEmailRecipients(): number { return this.vm.projectUserIds.length; }
        get emailBodyError(): string { return this.EmailBody.indexOf("{url}") === -1 ? "{url} is required in the message. " : null; }
        get hasErrors(): boolean { return this.emailBodyError != null; }

        EmailSubject: string = "Please complete this survey";
        EmailBody: string = "Please click on the following link to complete your survey: {url}";

        handleSendEmail()
        {
            this.$emit("send-email", this.EmailSubject, this.EmailBody);
        }

        close()
        {
            this.vm.close();
        }
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Send email ({{numberOfEmailRecipients}})</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <form id="scoring-survey-email-sender-form" @submit.prevent="handleSendEmail">
                            <div class="form-group">
                                <label>Subject:</label>
                                <input type="text" class="form-control" v-model.trim="EmailSubject" required>
                                <div class="error">{{emailSubjectError}}</div>
                            </div>
                            <div class="form-group">
                                <textarea rows="5" class="form-control" v-model.trim="EmailBody" required></textarea>
                                <div class="error">{{emailBodyError}}</div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button @click="close" type="button" class="btn btn-outline-secondary">Close</button>
                        <button type="submit" form="scoring-survey-email-sender-form" :disabled="hasErrors" class="btn btn-primary">Send email</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>